import { CheckBadgeIcon, InformationCircleIcon } from "@heroicons/react/24/solid";
import Button from "components/atoms/buttons/Button";
import { CloseIcon, LoadingIcon } from "components/atoms/Icon";
import Modal from "components/atoms/modal";
import { useState } from "react";
import { toast } from "react-toastify";
import { getEligibilityForMembersRoute } from "utils/helpers";
import { get } from "utils/request";
import { TOAST_CONFIG } from "../../constants";

type Props = {
  magnetPrice: number;
  onClose?: any;
  membershipConditions: string;
  brandId: string;
  magnetId: string;
  handleMagnetPurchase: () => void;
};

export default function BrandControlMagnetEligibilityModal({
  handleMagnetPurchase,
  membershipConditions,
  brandId,
  magnetId,
  magnetPrice,
  onClose,
}: Props) {
  const [isEligible, setIsEligible] = useState<boolean | null>(null);
  const [isFetchingEligibility, setIsFetchingEligibility] = useState(false);
  const [infoMessage, setInfoMessage] = useState("");

  const fetchEligibility = () => {
    setIsFetchingEligibility(true);
    get(getEligibilityForMembersRoute(brandId, magnetId), {
      processData: ({ data }) => {
        setIsFetchingEligibility(false);
        setInfoMessage(data.message);
        setIsEligible(data.curent_status === "ACTIVE");
      },
      processError: () => {
        setIsFetchingEligibility(false);
        toast.error("Something went wrong while checking Eligibility, please try again.", TOAST_CONFIG);
      },
    });
  };

  return (
    <Modal open onClose={onClose}>
      <div className="relative w-[98vw] max-w-[35rem] space-y-6 overflow-x-hidden rounded-2xl bg-primary p-3 text-white shadow-modal xl:p-6">
        <div className="flex justify-between text-white">
          <section className=" w-[95%] font-sora text-lg font-semibold md:text-xl xl:text-2xl">
            Check Your Eligibility:
          </section>
          <button type="button" onClick={onClose} className="my-auto -mt-0.5 cursor-pointer">
            <CloseIcon className="h-5 w-5 text-white" />
          </button>
        </div>
        <div className="flex flex-col gap-2">
          <div>
            <h3 className="text-sm underline">Exclusive Membership Program</h3>
            <p className="font-satoshi font-normal leading-snug opacity-50 md:font-medium">
              This Magnet program is currently marked as &lsquo;Memebers Only&rsquo; and only users earmarked by the
              brand can get into this program.
            </p>
          </div>
          <div>
            <h3 className="text-sm underline">Conditions for Membership</h3>
            <p className="whitespace-pre-line bg-white bg-opacity-0 font-satoshi font-normal leading-snug opacity-70 md:font-medium">
              {membershipConditions}
            </p>
          </div>
          <div className="space-y-1">
            {!isEligible && (
              <button
                className="text-blue-400 underline transition hover:text-blue-500"
                onClick={fetchEligibility}
                type="button"
              >
                Click here to check your eligibility
              </button>
            )}
            {isFetchingEligibility && (
              <p className="h-8 w-8">
                <LoadingIcon />
              </p>
            )}
            {isEligible !== null && (
              <div>
                {isEligible ? (
                  <p className="flex items-center gap-0.5 text-lime-500">
                    <CheckBadgeIcon className="h-[18px] w-[18px] " />
                    <span>{infoMessage}</span>
                  </p>
                ) : (
                  <p className="flex items-center gap-0.5 text-accent">
                    <InformationCircleIcon className="h-[18px] w-[18px] " />
                    <span>{infoMessage}</span>
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <Button additionalClasses="!py-2 !px-3" text="CLOSE" variant="rustPinkSolid" onClick={onClose} />
          {isEligible && (
            <Button
              additionalClasses="!py-2 !px-3"
              text={magnetPrice === 0 ? "CLAIM NOW" : "BUY MAGNET"}
              variant="magnetiqSolid"
              onClick={handleMagnetPurchase}
            />
          )}
        </div>
      </div>
    </Modal>
  );
}
